import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatErr, imgSrc } from "@/lib/api";

export const ImageField = ({ label, value, onChange, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      window.dispatchEvent(new Event("am:autosave"));
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); e.target.value = ""; }
  };

  const remove = () => { onChange(""); window.dispatchEvent(new Event("am:autosave")); };

  return (
    <div className="fe-field">
      <label>{label}</label>
      <div className="img-field">
        {value ? <img className="img-prev" src={imgSrc(value)} alt="" data-testid={`${testid}-preview`} /> : <div className="img-empty">brak zdjęcia</div>}
        <div className="fe-actions" style={{ flexWrap: "wrap" }}>
          <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden onChange={upload} data-testid={`${testid}-file`} />
          <button type="button" className="mini" onClick={() => ref.current.click()} disabled={busy} data-testid={`${testid}-upload-btn`}>{busy ? "Wgrywanie…" : value ? "Zmień zdjęcie" : "Wgraj zdjęcie"}</button>
          {value && <button type="button" className="mini danger" onClick={remove} data-testid={`${testid}-remove-btn`}>Usuń zdjęcie</button>}
        </div>
      </div>
    </div>
  );
};
